import { render } from "./CollectorPerformanceRankings.vue?vue&type=template&id=5d06c310&scoped=true"
import script from "./CollectorPerformanceRankings.vue?vue&type=script&lang=js"
export * from "./CollectorPerformanceRankings.vue?vue&type=script&lang=js"

import "./CollectorPerformanceRankings.vue?vue&type=style&index=0&id=5d06c310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d06c310"]])

export default __exports__